import { useTokenRefreshScheduler } from '@euler/app/flows/auth/useTokenRefreshScheduler';
import { memo } from 'react';

export const TokenRefreshScheduler = memo(() => {
  useTokenRefreshScheduler();
  return null;
});
